import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_THUOC_TINH_TAI_SAN,
  GET_THUOC_TINH_TAI_SAN1,
} from "actions/ThuocTinhTaiSan/actionTypes";
import {
  getThuocTinhTaiSanSuccess,
  getThuocTinhTaiSanFailure,
  getThuocTinhTaiSan1Success,
  getThuocTinhTaiSan1Failure,
} from "actions/ThuocTinhTaiSan";
import ThuocTinhTaiSanApi from "service/thuocTinhTaiSanApi";
import { pushNotification } from "utils/notifications";

function* getThuocTinhTaiSan(action) {
  try {
    const response = yield call(ThuocTinhTaiSanApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getThuocTinhTaiSanSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getThuocTinhTaiSanFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getThuocTinhTaiSanFailure());
  }
}

function* getThuocTinhTaiSan1(action) {
  try {
    const response = yield call(ThuocTinhTaiSanApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getThuocTinhTaiSan1Success(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getThuocTinhTaiSan1Failure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getThuocTinhTaiSan1Failure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_THUOC_TINH_TAI_SAN, getThuocTinhTaiSan);
  yield takeLatest(GET_THUOC_TINH_TAI_SAN1, getThuocTinhTaiSan1);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
